var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 14.2681C8.75 13.8539 9.08579 13.5181 9.5 13.5181L13.5522 13.5181L13.5522 2.49068L9.5 2.49068C9.08579 2.49068 8.75 2.15489 8.75 1.74068C8.75 1.32647 9.08579 0.990681 9.5 0.990681L14.3022 0.99068C14.7164 0.99068 15.0522 1.32647 15.0522 1.74068L15.0522 14.2681C15.0522 14.6823 14.7164 15.0181 14.3022 15.0181L9.5 15.0181C9.08579 15.0181 8.75 14.6823 8.75 14.2681Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36161 11.5L1.75 8M1.75 8L4.36161 4.5M1.75 8L10.3 8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.ba86013195ff4265c3929a8563097c62.svg";
export { ForwardRef as ReactComponent };